// test1130
(1130 && 0);
